import ServiceOutline from '@pages/Beneficiary-block/WomenComponent/ANC/CommonOutline/AddServiceOutline';
import CommonFormFields from '@pages/Forms/CommonFormFields';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RootState } from '@store/reducers';
import AlertPopup from '../CreateNewChild/AlertPopup';
import "./Abortion.css"
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { errorLogger } from '@utils/applicationLogUtils';
import { setAncPregBackHandler, setBeneficiaryDetails, setBeneficiaryPregnancyHistory, setPregnancyDetails, setShowServices, updatePNC } from '@store/actions/beneficiaryAction';
import { ABORTION_ERROR_MESSAGES, ABORTION_FIELDS_NAME, abortionData, abortionObj, COMMON_ABORTION_CONSTANTS } from './AbortionConstants';
import { createAbortion, getServiceReportByParams } from './AbortionService';
import { getOngoingPNCDetails } from '../PNC/PNCConstants';
import FormatDate from '@utils/dateFormat';
import { DELIVERY_COMMON_CONSTANTS, getPNCDetails } from '../DeliveryOutcome/constants/DeliveryConstants';
import { getDataWithCache, getData } from '@services/CommonApiService';
import endpoints from '@config/endpoints';
import dayjs from 'dayjs';
import config from '@config/config';
import { getLatestServiceAvailedDateByBenefId } from '@services/beneficiaryApiServices';
import { error } from '@constants/ancConstants';

interface objectType {
  isError: boolean;
  message: string;
  isDisable: boolean;
  value: any;
  id?: any;
  code?: any;
}
export interface formStateType {
  [key: string]: objectType;
}

const AbortionForm = () => {

  const breadcrumbItemName = [{ value: 'beneficiary', label: 'Abortion' }];

  const [abortionFormState, setAbortionFormState] = useState<formStateType>(abortionObj);
  const [abortionFormData, setAbortionFormData] = useState<any>(abortionData);
  const [navItemsModal, setnavItemsModal] = useState(['Abortion Details']);
  const [alertModalOpen, setAlertModalOpen] = useState<boolean>(false);
  const [formCompleted, setFormCompleted] = useState<boolean[]>([false]);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [selectPerc, setSelectedPerc] = useState<any>(0);
  const [modalTitle, setModalTitle] = useState<string>('');
  const [deliveryStatusResponse, setDeliveryStatusResponse] = useState<any>('');
  const [serviceIds, setServiceIds] = useState<any>({});

  const benfDetails = useSelector((state: RootState) => state.beneficiary.beneficiaryDetails,);
  const pregnancyId = useSelector((state: RootState) => state.beneficiary.currPregnancyId,);
  const currentFacilityDetails = useSelector((state: RootState) => state.beneficiary.currentFacilityDetails,);
  const currServiceSubCtgryId = useSelector((state: RootState) => state.beneficiary.currServiceSubCtgryId);
  const serviceCategoryId = useSelector((state: RootState) => state.beneficiary.serviceCtgryId);
  const viewPregnancyDetails = useSelector((state: RootState) => state.beneficiary.viewPregnancyDetails);

  const [actionSource, setActionSource] = useState('');

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navs = 100 / navItemsModal.length;
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    initialFetch();
  }, []);

  const initialFetch = async () => {
    try {
      const latestAvailedServiceDateRes = await getLatestServiceAvailedDateByBenefId(benfDetails?.[0]?.benef_id, true);
      const latestAvailedServiceDate = latestAvailedServiceDateRes?.data?.[0]?.get_latest_service_availed_date_for_benef;
      const typeOfAbortionResponse: any = await getServiceReportByParams(COMMON_ABORTION_CONSTANTS.ABORTION_TYPE);
      const methodOfAbortionResponse: any = await getServiceReportByParams(COMMON_ABORTION_CONSTANTS.METHOD_OF_ABORTION);
      const postAbortionResponse: any = await getServiceReportByParams(COMMON_ABORTION_CONSTANTS.POST_ABORTION);
      const deliveryStatusResponse = await getDataWithCache<any>(endpoints.deliveryStatus);
      setDeliveryStatusResponse(deliveryStatusResponse?.data);

      const reportServiceIds = {
        typeOfAbortionServiceId: typeOfAbortionResponse?.data[0]?.service_id,
        methodOfAbortionServiceId: methodOfAbortionResponse?.data[0]?.service_id,
        postAbortionServiceId: postAbortionResponse?.data[0]?.service_id,
      };
      setServiceIds(reportServiceIds);
      const minDate = viewPregnancyDetails?.lmp;
      setAbortionFormData((prevState: any) => ({
        ...prevState,
        typeOfAbortion: {
          ...prevState.typeOfAbortion,
          '#options': mapToOptions(typeOfAbortionResponse?.data),
        },
        methodOfAbortion: {
          ...prevState.methodOfAbortion,
          '#options': mapToOptions(methodOfAbortionResponse?.data),
        },
        postAbortion: {
          ...prevState.postAbortion,
          '#options': mapToOptions(postAbortionResponse?.data),
        },
        dateOfAbortion: {
          ...prevState.dateOfAbortion,
          '#minDate': latestAvailedServiceDate ? dayjs(latestAvailedServiceDate) : minDate,
          '#maxDate': minDate ? (dayjs(minDate).add(20, 'week').isAfter(dayjs()) ? dayjs() : dayjs(minDate).add(20, 'week')) : dayjs(),
        }
      }));
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error);
    }
  };

  const mapToOptions = (data: any) => {
    return data?.map((key: any) => ({
      value: key.report_name,
      label: key.report_name,
      id: key.report_id,
      code: key.report_code,
    }));
  }

  const isFormChanged = (abortionFormState: any) => {
    for (const key in abortionObj) {
      if (abortionFormState[key].value !== abortionObj[key].value) {
        return true;
      }
    }
    return false;
  };

  const onHandleBackArrowButton = () => {
    setActionSource('back');
    if (isFormChanged(abortionFormState)) {
      setModalTitle(ABORTION_ERROR_MESSAGES.UNSAVED_CHANGES);
      setAlertModalOpen(true);
      return;
    }
    navigate(-1);
  };

  const handleAbortionForm = (value: any, key: string, id: any, option: any, code: any, changedData: any) => {
    if (key === 'typeOfAbortion') {
      if (value && value === 'Induced') {
        setAbortionFormData((prevState: any) => ({
          ...prevState,
          methodOfAbortion: {
            ...prevState.methodOfAbortion,
            '#isDisabled': false,
            '#required': true,
          },
          postAbortion: {
            ...prevState.postAbortion,
            '#isDisabled': false,
            '#required': true,
          },
          dateOfAbortion: {
            ...prevState.dateOfAbortion,
            '#isDisabled': false,
            '#required': true,
          },
        }));
      } else if (value) {
        setAbortionFormData((prevState: any) => ({
          ...prevState,
          postAbortion: {
            ...prevState.postAbortion,
            '#isDisabled': false,
            '#required': true,
          },
          dateOfAbortion: {
            ...prevState.dateOfAbortion,
            '#isDisabled': false,
            '#required': true,
          },
          methodOfAbortion: {
            ...prevState.methodOfAbortion,
            '#required': false,
            '#isDisabled': true,
          },
        }));
      } else {
        setAbortionFormData((prevState: any) => ({
          ...prevState,
          methodOfAbortion: {
            ...prevState.methodOfAbortion,
            '#isDisabled': true,
            '#required': false,
          },
          postAbortion: {
            ...prevState.postAbortion,
            '#isDisabled': true,
            '#required': false,
          },
          dateOfAbortion: {
            ...prevState.dateOfAbortion,
            '#isDisabled': true,
            '#required': false,
          },
        }));
        setAbortionFormState(abortionObj);
      }
    }

    if (key === "hprName") {
      setAbortionFormState((prevState: any) => {
        return {
          ...prevState,
          ashaName: {
            ...prevState.ashaName,
            value: '',
          },
        };
      });
      if (value) {
        fetchAshaName(changedData?.ufTaggedId);
      } else {
        setAbortionFormData((prevState: any) => {
          return {
            ...prevState,
            ashaName: {
              ...prevState.ashaName,
              '#options': [],
            },
          };
        });
      }
    }
    else if (key === 'dateOfVisit') {
      if (value) {
        const lmp = viewPregnancyDetails?.lmp;
        const lmpPlus20Weeks = lmp ? dayjs(lmp).add(20, 'week') : null;
        const visitDate = dayjs(value);
        const abortionMaxDate = lmpPlus20Weeks
          ? (lmpPlus20Weeks.isBefore(visitDate) ? lmpPlus20Weeks : visitDate)
          : visitDate;
        setAbortionFormData((prevState: any) => ({
          ...prevState,
          dateOfAbortion: {
            ...prevState.dateOfAbortion,
            '#maxDate': abortionMaxDate,
          },
        }));
        if (
          abortionFormState.dateOfAbortion.value &&
          dayjs(value).isBefore(dayjs(abortionFormState.dateOfAbortion.value))
        ) {
          setAbortionFormState((prevState: any) => ({
            ...prevState,
            dateOfAbortion: {
              ...prevState.dateOfAbortion,
              value: '',
            },
          }));
        }
      } else {
        const lmp = viewPregnancyDetails?.lmp;
        const lmpPlus20Weeks = lmp ? dayjs(lmp).add(20, 'week') : null;
        const abortionMaxDate = lmpPlus20Weeks
          ? (lmpPlus20Weeks.isBefore(dayjs()) ? lmpPlus20Weeks : dayjs())
          : dayjs();
        setAbortionFormState((prevState: any) => ({
          ...prevState,
          dateOfAbortion: {
            ...prevState.dateOfAbortion,
            value: '',
          },
        }));
        setAbortionFormData((prevState: any) => ({
          ...prevState,
          dateOfAbortion: {
            ...prevState.dateOfAbortion,
            '#maxDate': abortionMaxDate,
          },
        }));
      }
    }
    else if (key === 'dateOfAbortion') {
      if (value) {
        const ninetyDaysAgo = dayjs().subtract(config.serviceDateLimit, 'day');
        const visitMinDate = dayjs(value).isAfter(ninetyDaysAgo) ? dayjs(value) : ninetyDaysAgo;
        setAbortionFormData((prevState: any) => ({
          ...prevState,
          dateOfVisit: {
            ...prevState.dateOfVisit,
            '#minDate': visitMinDate,
          },
        }));
        if (
          abortionFormState.dateOfVisit.value &&
          dayjs(abortionFormState.dateOfVisit.value).isBefore(visitMinDate)
        ) {
          setAbortionFormState((prevState: any) => ({
            ...prevState,
            dateOfVisit: {
              ...prevState.dateOfVisit,
              value: '',
            },
          }));
        }
      } else {
        setAbortionFormData((prevState: any) => ({
          ...prevState,
          dateOfVisit: {
            ...prevState.dateOfVisit,
            '#minDate': dayjs().subtract(config.serviceDateLimit, 'day'),
          },
        }));
      }
    }


    setAbortionFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value ? value : '',
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
  };

  const contents = [
    <div key="Abortion Related Details">
      <form className="abortion-form-container">
        <CommonFormFields
          formData={abortionFormData}
          formState={abortionFormState}
          handleFormChange={handleAbortionForm}
        />
      </form>
    </div>
  ];

  const handleSubmit = async () => {
    const isFormError = handleFormError();

    if (!isFormError) {
      try {
        const deliveryStatusId = deliveryStatusResponse?.find((item: any) => item.delivery_status_code === DELIVERY_COMMON_CONSTANTS.ABORTION)?.delivery_status_id;
        const visitDate = FormatDate(currentFacilityDetails?.visitDate);
        const pncDetails = getPNCDetails(abortionFormState.dateOfAbortion.value);
        const abortionPayload = {
          beneficiaryId: benfDetails[0]?.benef_id,
          pregNancyId: pregnancyId,
          serviceCategoryId: serviceCategoryId,
          serviceSubCategoryId: currServiceSubCtgryId,
          visitDate: dayjs(abortionFormState.dateOfVisit.value).format('YYYY-MM-DD'),
          dateOfAbortion: FormatDate(abortionFormState.dateOfAbortion.value),
          typeOfAbortionServiceId: serviceIds?.typeOfAbortionServiceId,
          typeOfAbortionReportId: abortionFormState.typeOfAbortion.id,
          methodOfAbortionServiceId: serviceIds?.methodOfAbortionServiceId,
          methodOfAbortionReportId: abortionFormState.methodOfAbortion.id,
          postAbortionServiceId: serviceIds?.postAbortionServiceId,
          postAbortionReportId: abortionFormState.postAbortion.id,
          facilityId: abortionFormState?.facilityName.id,
          healthProviderId: abortionFormState?.hprName.id,
          mobiliserId: abortionFormState?.ashaName?.id || null,
          deliveryStatusId: deliveryStatusId,
          parentUserId: userId,
          pncOneStartDate: pncDetails[0].startDate,
          pncOneEndDate: pncDetails[0].endDate,
          pncTwoStartDate: pncDetails[1].startDate,
          pncTwoEndDate: pncDetails[1].endDate,
          pncThreeStartDate: pncDetails[2].startDate,
          pncThreeEndDate: pncDetails[2].endDate,
          pncFourStartDate: pncDetails[3].startDate,
          pncFourEndDate: pncDetails[3].endDate,
          pncFiveStartDate: pncDetails[4].startDate,
          pncFiveEndDate: pncDetails[4].endDate,
          pncSixStartDate: pncDetails[5].startDate,
          pncSixEndDate: pncDetails[5].endDate,
          pncSevenStartDate: pncDetails[6]?.startDate,
          pncSevenEndDate: pncDetails[6]?.endDate,
        }
        const res:any = await createAbortion(abortionPayload);
        if (res.data && !(res.data?.data && res.data?.data[0][0] && res.data?.data[0][0]['error_msg'])) {
          const newFormCompleted = [...formCompleted];
          newFormCompleted[activeIndex] = true;
          setFormCompleted(newFormCompleted);
          const perc = (activeIndex + 1) * navs;
          setSelectedPerc(perc);
          navigate(`/beneficiaries/view/${benfDetails[0]?.benef_id}`);
          toast.success(COMMON_ABORTION_CONSTANTS.SUCCESS_MSG, {
            position: "top-center"
          });
          const pncPregBackObj = {
            benfType: "female",
            menuItems: "Pregnancy Services",
          }
          dispatch(setAncPregBackHandler(pncPregBackObj));
          dispatch(updatePNC('currentFacilityDetails', {}));
          dispatch(updatePNC('currPregnancyId', ''));
          dispatch(setShowServices(false));
          dispatch(setBeneficiaryDetails([]));
          dispatch(setBeneficiaryPregnancyHistory({}));
          dispatch(setPregnancyDetails({}));
        }
        else {
          toast.error(error.errorMessage, {
            position: "top-center"
          });
        }
      } catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error);
      }
    } else {
      const newFormCompleted = [...formCompleted];
      newFormCompleted[activeIndex] = false;
      setFormCompleted(newFormCompleted);
      const perc = (activeIndex - 1) * navs;
      setSelectedPerc(perc);
    }
  };

  const handleCancel = () => {
    setActionSource('cancel');
    if (isFormChanged(abortionFormState)) {
      setModalTitle(ABORTION_ERROR_MESSAGES.UNSAVED_CHANGES);
      setAlertModalOpen(true);
      return;
    }
    setModalTitle(COMMON_ABORTION_CONSTANTS.CLOSE_FORM);
    setAlertModalOpen(true);
  };

  const handleFormError = () => {
    let checkError = false;
    if (!abortionFormData.dateOfAbortion['#isDisabled'] && !abortionFormState.dateOfAbortion.value) {
      setAbortionFormState((prevState: any) => ({
        ...prevState,
        dateOfAbortion: {
          ...prevState.dateOfAbortion,
          isError: true,
          message: ABORTION_ERROR_MESSAGES.FIELD_REQUIRED(ABORTION_FIELDS_NAME.DATE_OF_ABORTION),
        },
      }));
      checkError = true;
    }
    if (!abortionFormData.typeOfAbortion['#isDisabled'] && !abortionFormState.typeOfAbortion.value) {
      setAbortionFormState((prevState: any) => ({
        ...prevState,
        typeOfAbortion: {
          ...prevState.typeOfAbortion,
          isError: true,
          message: ABORTION_ERROR_MESSAGES.FIELD_REQUIRED(ABORTION_FIELDS_NAME.TYPE_OF_ABORTION),
        },
      }));
      checkError = true;
    }
    if (!abortionFormData.methodOfAbortion['#isDisabled'] && !abortionFormState.methodOfAbortion.value) {
      setAbortionFormState((prevState: any) => ({
        ...prevState,
        methodOfAbortion: {
          ...prevState.methodOfAbortion,
          isError: true,
          message: ABORTION_ERROR_MESSAGES.FIELD_REQUIRED(ABORTION_FIELDS_NAME.METHOD_OF_ABORTION),
        },
      }));
      checkError = true;
    }
    if (!abortionFormData.postAbortion['#isDisabled'] && !abortionFormState.postAbortion.value) {
      setAbortionFormState((prevState: any) => ({
        ...prevState,
        postAbortion: {
          ...prevState.postAbortion,
          isError: true,
          message: ABORTION_ERROR_MESSAGES.FIELD_REQUIRED(ABORTION_FIELDS_NAME.POST_OF_ABORTION),
        },
      }));
      checkError = true;
    }
    if (!abortionFormData.facilityType['#isDisabled'] && !abortionFormState.facilityType.value) {
      setAbortionFormState((prevState: any) => ({
        ...prevState,
        facilityType: {
          ...prevState.facilityType,
          isError: true,
          message: 'Select Facility Type from the dropdown.',
        },
      }));
      checkError = true;
    }
    if (!abortionFormData.facilityName['#isDisabled'] && !abortionFormState.facilityName.value) {
      setAbortionFormState((prevState: any) => ({
        ...prevState,
        facilityName: {
          ...prevState.facilityName,
          isError: true,
          message: 'Select Facility Name from the dropdown.',
        },
      }));
      checkError = true;
    }
    if (!abortionFormData.hprName['#isDisabled'] && !abortionFormState.hprName.value) {
      setAbortionFormState((prevState: any) => ({
        ...prevState,
        hprName: {
          ...prevState.hprName,
          isError: true,
          message: 'Select Health Provider Name from the dropdown.',
        },
      }));
      checkError = true;
    }
    if (!abortionFormData.dateOfVisit['#isDisabled'] && !abortionFormState.dateOfVisit.value) {
      setAbortionFormState((prevState: any) => ({
        ...prevState,
        dateOfVisit: {
          ...prevState.dateOfVisit,
          isError: true,
          message: 'Select Date Of Visit from the calendar.',
        },
      }));
      checkError = true;
    }
    return checkError;
  };

  const closeAlertModal = (value: boolean, title: any, action: any) => {
    if (value) {
      setAlertModalOpen(false);
      const serviceDetails = {
        currRoute: currentFacilityDetails?.currRoute,
      }
      // if (action === 'back') {
      //   navigate('/beneficiaries/pnc/service', { state: serviceDetails });
      // } else {
      const pncPregBackObj = {
        benfType: "female",
        menuItems: "Pregnancy Services",
      }
      dispatch(setAncPregBackHandler(pncPregBackObj));
      dispatch(updatePNC('currentFacilityDetails', {}));
      dispatch(updatePNC('currPregnancyId', ''));
      dispatch(updatePNC('isPNCFirstVisit', false));
      navigate(`/beneficiaries/view/${benfDetails[0]?.benef_id}`);
      // }
    }
    else {
      setAlertModalOpen(false);
    }
  };

  useEffect(() => {
    getFacilityData();
  }, []);

  const getFacilityData = async () => {
    try {
      const facilityDetailsRespone = await getDataWithCache<any>(`${endpoints.getLinkedFacilitiesByUserById}/${userId}`);
      const parentFacility = facilityDetailsRespone.data[0]?.find((item: any) => item.is_parent === true,);
      const facilityTypeOptions = facilityDetailsRespone?.data[0]?.map((key: any) => ({
        value: key.facility_type_name,
        label: key.facility_type_name,
        id: key.facility_type_id,
        code: key.facility_type_code,
      }),
      );
      const facilityNameOptions = facilityDetailsRespone?.data[0]?.map((key: any) => ({
        value: key.facility_name,
        label: key.facility_name,
        id: key.facility_id,
        code: key.facility_code,
      }))

      setAbortionFormState((prevState: any) => ({
        ...prevState,
        facilityName: {
          ...prevState.facilityName,
          value: parentFacility?.facility_name,
          id: parentFacility?.facility_id,
        },
        facilityType: {
          ...prevState.facilityType,
          value: parentFacility?.facility_type_name,
          id: parentFacility?.facility_type_id,
        },
      }));
      setAbortionFormData((prevState: any) => {
        return {
          ...prevState,
          facilityType: {
            ...prevState.facilityType,
            '#options': facilityTypeOptions,
          },
          facilityName: {
            ...prevState.facilityName,
            '#options': facilityNameOptions,
          },
        };
      });
      fetchHprName(parentFacility?.facility_id);
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error)
    }
  }

  const fetchHprName = async (id: any) => {
    if (id) {
      try {
        const Health_provider = await getDataWithCache<any>(`${endpoints.getHealthProviderTagged(id)}`);
        const healthProviderOptions = Health_provider?.data?.map((key: any) => ({
          value: `${key?.f_name} ${key?.l_name}`,
          label: `${key?.f_name} ${key?.l_name}`,
          id: key?.user_id,
          code: key?.user_code,
          ufTaggedId: key?.uf_tagged_id,
        }));
        setAbortionFormData((prevState: any) => {
          return {
            ...prevState,
            hprName: {
              ...prevState.hprName,
              '#options': healthProviderOptions,
            },
          };
        });
      } catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error)
      }
    }
  };

  const fetchAshaName = async (ufTaggedId: any) => {
    try {
      const ashaNameRes = await getDataWithCache<any>(`${endpoints.getMobiliserTagged(ufTaggedId)}`);
      const ashanameOptions = ashaNameRes?.data.map((key: any) => ({
        value: key?.f_name + ' ' + key?.l_name,
        label: key?.f_name + ' ' + key?.l_name,
        id: key?.mobiliser_id,
        code: key?.user_code,
      }));
      setAbortionFormData((prevState: any) => {
        return {
          ...prevState,
          ashaName: {
            ...prevState.ashaName,
            '#options': ashanameOptions,
          },
        };
      });
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error)
    }
  }

  return (
    <>
      <ServiceOutline
        breadcrumbItemName={breadcrumbItemName}
        onHandleBackArrowButton={onHandleBackArrowButton}
        navItemsModal={navItemsModal}
        activeIndex={0}
        formCompleted={formCompleted}
        headerName={'Abortion'}
        progressBarPerc={selectPerc}
        contents={contents}
        finishHandler={() => handleSubmit()}
        handleCancel={handleCancel}
        title='Add Details'
      />
      <AlertPopup
        showModal={alertModalOpen}
        closeModal={(value: boolean) => closeAlertModal(value, modalTitle, actionSource)}
        title={modalTitle}
      />
    </>
  );
};

export default AbortionForm;
